import React, { useRef } from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
function RealTimeTemperature(props) {
  const dictionarySelection = (value) => {
    return props.utcObj[value];
  };

  const series = [];

  if (props.tempAEnabled) {
    series.push({
      type: "line",
      data: props.aData,
      name: "Temp A",
      color: "red",
      zIndex: 2,
    });
  }

  if (props.tempBEnabled) {
    series.push({
      type: "line",
      data: props.bData,
      name: "Temp B",
      color: "blue",
      zIndex: 1,
    });
  }
  
  const options = {
    title: {
      text: "",
    },
    tooltip: {
      formatter: function () {
        return this.points.reduce(function (s, point) {
          return (
            s +
            "<br/>" +
            point.series.name +
            ": " +
            "<b>" +
            point.y +
            `\xB0C` +
            "</b>"
          );
        }, "<b>" + dictionarySelection(this.x) + "</b>");
      },
      shared: true,
    },
    xAxis: {
      type: "datetime",
      tickInterval: 3600 * 1000,
    },
    series,
  };
  const chart = useRef();
  const data = <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />;

  return (
    <ToggleBar
      caption="Realtime Temperature"
      // download={handleChartDownLoad}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default RealTimeTemperature;
